import { SIZE } from '@/pages/Meeting/component/BarragePanel/components/FontSlider';
import { TranscribeStatus } from '@/pages/Meeting/component/ControlBar/PC/TranscribeBtn';
import { observable, action, makeObservable } from 'mobx';
import { meeting } from '.';
import { Lang } from '@/types/lang';

class Transcribe {
  constructor() {
    makeObservable(this);
  }

  @observable transcribeVisible = false;

  @observable fontSize = SIZE[1];
  // 字幕识别源语言
  @observable originLang = Lang.zh;

  //字幕目标语言
  @observable targetLang = Lang.auto;

  // 转录是否翻译过
  @observable translate = false;
  // 设置字幕识别源语言

  // web 转录状态
  @observable transcribeStatus = TranscribeStatus.notTranscribe;

  @action
  setOriginLang(value: Lang, translate: boolean) {
    this.originLang = value;
    this.translate = translate;
  }
  // 设置字幕目标语言
  @action
  setTargetLang(value: Lang, translate: boolean) {
    this.targetLang = value;
    this.translate = translate;
  }

  @action
  setBarrageFontSize(value: number) {
    this.fontSize = value;
  }
  @action
  setTranscribeVisible(visible: boolean) {
    this.transcribeVisible = visible;
  }
  @action
  setTranscribeStatus(status: TranscribeStatus) {
    this.transcribeStatus = status;
  }

  @action
  getTranscribeStatus() {
    API.api.webSubtitleV3.getTranscriptionStatus
      .request({
        channelId: meeting.info?.channelId,
        meetingId: meeting.info?.meetingId,
      })
      .then((res) => {
        if (res && res.data?.transcriptionStatus) {
          const status = res.data.transcriptionStatus;
          this.transcribeStatus = status;
        }
      });
  }
}

export default Transcribe;
